import React, { useState } from 'react';
import { FormControl, MenuItem, TextField } from '@mui/material';
import { useDeliveryGroup } from '../../customHooks/useDeliveryGroup';

const Filter = ({ isMdUp ,width="100%"}) => {
  const { selectedFilter, setSelectedFilter } = useDeliveryGroup();

  const handleChange = (event) => {
    setSelectedFilter(event.target.value);
  };
  const menuItemStyle = { textAlign: 'center', fontSize: '14px' };
  return (
    <FormControl sx={{ width: '100%' }}>
      <TextField
        sx={{
          background: 'transparent',
        }}
        select
        labelId="filter-by-label"
        id="filter-by-select"
        value={selectedFilter}
        label={'Filter by'}
        onChange={handleChange}
        size="small"
        InputProps={{
          sx: {
            width: width,
            minWidth: '160px',
            height: '40px',
            background: 'transparent',
            borderRadius: '30px',
            fontSize: '14px',
            '& fieldset': {
              borderRadius: '30px',
            },
            '&:hover': {
              '& fieldset': {
                border: '1px solid #3F2F5B',
                borderColor: '#3F2F5B !important',
              },
            },
            '&.Mui-focused': {
              '& fieldset': {
                borderColor: '#FF7676 !important',
              },
            },
          },
        }}
      >
        <MenuItem sx={menuItemStyle} value="all">
          All
        </MenuItem>
        <MenuItem sx={menuItemStyle} value="is_active=true">
          Active Customers
        </MenuItem>
        <MenuItem sx={menuItemStyle} value="payment_due=true">
          Payment Due Customers
        </MenuItem>
        <MenuItem sx={menuItemStyle} value="halted=true">
          Customers Halted Today
        </MenuItem>
      </TextField>
    </FormControl>
  );
};

export default Filter;
